import { Logger } from '@shared/utils'

const log = Logger('GTM')

export const sendNewGTMEvent = (event, params = {}) => {
  const id = generateUUIDv4()
  const filteredParams = Object.fromEntries(Object.entries(params).filter(([_, value]) => Boolean(value)))
  const content = { id, event, params: filteredParams }

  if (import.meta.env.VITE_ENABLE_GTM !== 'true') return log.debug('Disabled:', content)
  if (!window.dataLayerNew) return log.warn('Not Initialized:', content)

  window.dataLayerNew.push(content)
  log.debug('Success:', content)
}

function generateUUIDv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
